import * as Common from '@/agiles/common';

export class ReportTemplate extends Common.StateObject {
  constructor() {
    super('ReportTemplate');
    this.binders.controller = new Common.ModelBinder(LayoutController);
    this.workflowCode="approval";
    this.workflowStateId = Common.ApprovalStatus.NotApproved;//フラグ値を変更;          
  }
  public get actionTooltip() {
    if (this.state == Common.ApprovalStatus.NotApproved)　return '使用を開始する場合は【公開】をクリックします。';
    else if (this.state == Common.ApprovalStatus.Approved) return '内容を修正する場合は【公開取消】をクリックします。';     
    else return '';
  }  
  public id: number = 0;
  public queryName: string;
  public viewName: string;
  public reportName: string;
  public fileName: string;
  public locale:string = 'ja';
  public fileTimeStamp: Date = null;
  public uploadTimeStamp: Date = null;  
  public isSystemOwned:boolean = false;
  public sourceId:number;
  public sendMail:SendMailFlags = SendMailFlags.none;
  public mailSubject:string;
  public mailBody:string;
  public isSentFromClient: boolean = true;
  public useCustomPaperSize: boolean = false;
  public customPaperSizeWidth: number = 0;
  public customPaperSizeHeight: number = 0;
  public get componentName() :string{
    return this._controller.componentName;
  }
  public get controllerName(){
    if (this.controller)return this.controller.name;
    else return '';
  }
  public get name(){
    return this.reportName;
  }
  public get controller() {
    return this._controller;
  }
  public set controller(value: LayoutController) {
    this._controller = value;
    if (value){
    this.queryName = value.queryName;
    this.viewName = value.viewName;
    }

  }
  _controller: LayoutController = null;
  public get isSendThisReport(): boolean {
    if (this.sendMail > 0) return true;
    else return false;
  }
  public set isSendThisReport(value: boolean) {
    if (value) this.sendMail = SendMailFlags.listmenu | SendMailFlags.workflow;
    else this.sendMail = SendMailFlags.none;
  }

  public copy():any {
    const temp = super.copy() as ReportTemplate;
    temp.id = 0;

    //temp.fileName = '';
    //temp.fileTimeStamp = null;
    //temp.uploadTimeStamp = null;
    temp.isSystemOwned = false; //ユーザー帳票にリセット
    temp.sourceId = this.id;
    return temp;
  }  
  public get messageOnEdit():string { 
    return '「公開取消」をクリックして状態を「公開待ち」に戻してから編集してください。';  
  }    
  public get messageOnDelete():string {
    return '「公開取消」をクリックして状態を「公開待ち」に戻してから削除してください。';
  }
  public getTargetState(stateId : number, actionFlag : Common.DefaultActionFlags){
    //編集=>公開中
    if (actionFlag == Common.DefaultActionFlags.edit && stateId ==  Common.ApprovalStatus.Approved)
      return Common.ApprovalStatus.NotApproved;
    //削除=>なし
    //更新=>未確定・編集中
    else if (actionFlag == Common.DefaultActionFlags.update &&  stateId ==  Common.ApprovalStatus.NotApproved)
      return Common.ApprovalStatus.Approved;
    else if (actionFlag == Common.DefaultActionFlags.add && stateId == Common.ApprovalStatus.NotApproved)
      return Common.ApprovalStatus.Approved;        
    else
      return 0;
  }    
}
export enum SendMailFlags{
  none,listmenu,workflow
}
export class ReportTemplateQuery extends Common.LoadQuery {
  constructor() {
    super('ReportTemplateQuery', ReportTemplate);
    this.sort = 'viewName';
  }
  public viewName: string;  
  public reportName: string;
  public queryName: string;
  public id:number;
  public state: Common.ApprovalStatus = Common.ApprovalStatus.Approved;  
}

export class ReportTemplateMasterQuery extends ReportTemplateQuery{
    constructor() {
      super();
      this.state = null;
    }
}

export class ReportTemplateViewQuery extends Common.LoadQuery {
  constructor() {
    super('ReportTemplateViewQuery', ReportTemplate);
    this.sort = 'viewName';
  }
  public viewName: string;  
}
export class ReportTemplateUploadQuery extends Common.Query {
    constructor(){
        super('ReportTemplateUploadQuery', new Common.ModelBinder(ReportTemplate,false))
    }
    public templateId:number = 0;
    public timestamp:string = '';
    public isSentFromClient = true;
}

export class ReportTemplateDownloadQuery extends Common.Query {
    constructor(templateId:number){
        super('ReportTemplateDownloadQuery', null);
        this.templateId = templateId;
    }
    public templateId:number = 0;
}
export class LayoutController extends Common.ObjectBase {
  constructor() {
    super('LayoutController');
  }
  public name: string;
  public queryName: string;
  public viewName: string;
  public itemNames: Common.BindItem[];
  public groupingFields: { [key: string]: Common.BindItem[] } = {};
  public componentName :string;  
  public supportMail:boolean;
}

export class LayoutControllerQuery extends Common.LoadQuery {
  constructor() {
    super('LayoutControllerQuery', LayoutController);
  }
}

export class ReportQuery extends Common.Query {
    constructor(className:string, query:Common.LoadQuery){
        super(className, null);
        this.query = query;
    }
    public query: Common.LoadQuery = null;
    public templateId:number=0;
}

export class ReportQuery2 extends Common.Query {
    constructor(className:string, items:any[]){
        super(className, null);
        this.items = items;
    }
    public items: any[] = null;
    public templateId:number=0;
    public onExcelFormat:boolean = false;
    public onExportSystemLog:boolean = false;
}

export class ReportSendQuery extends Common.Query {
  constructor(modelName:string, items:any[], templateId:number, emailInfos?: Common.EmailInfo[], keyList:any[] = null, isMultipleReportSend?:boolean){
    super("ReportSendQuery!" + modelName,null); //ジェネリック型としてサーバーに転送。レスポンスバインダは不要
    this.items = keyList ? null : items;
    this.keyList = keyList;
    this.templateId = templateId;
    this.emailInfos = emailInfos;
    this.isMultipleReportSend = isMultipleReportSend;
  }
  public items: any[] = null;
  public keyList:any[] = null;
  public templateId:number=0;
  public isAsync:boolean = true; //非同期実行
  public emailInfos: Common.EmailInfo[] = null;
  public isMultipleReportSend: boolean = false;
}

export class WorkflowReportTemplateQuery extends Common.Query {
  constructor(workflowControllerName:string){
    super("WorkflowReportTemplateQuery", new Common.ModelBinder(Common.BindItem2,true)); //ジェネリック型としてサーバーに転送。レスポンスバインダは不要
    this.workflowControllerName = workflowControllerName;
  }
  public workflowControllerName :string;
}

export class SendTestMailQuery extends Common.Query {
    constructor(){
        super("SendTestMailQuery", null);
    }  
}
export class PreviewVoucherNoQuery extends Common.Query{
  constructor(viewName : string){
    super('PreviewVoucherNoQuery', null);
    this.viewName = viewName;
  }
  public viewName : string = null;
}